import { createSelector } from "reselect";
import { values } from "lodash";
//EXTRACT THE PART OF THE STATE
const getData = state => state.data.education;

const getEducation = createSelector(getData, education => values(education));

export default getEducation;



// WEBPACK FOOTER //
// ./src/_selectors/dataSelectors/getEducation.js